import React, { useState } from 'react';
import Header from './../Common/Header';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';
import GoogleMapReact from 'google-map-react';

var bnrimg = require('./../../images/banner/4.jpg');

const AnyReactComponent = ({ text }) => <div>{text}</div>;

const   ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = e => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch("https://alaussback-production.up.railway.app/api/contacts/create", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                throw new Error("Failed to send message");
            }

            setSubmitted(true);
            setFormData({ name: '', email: '', message: '' });
        } catch (err) {
            setError(err.message);
        }
    };

    const defaultProps = {
        center: {
            lat: 34.073280,
            lng: -118.251410
        },
        zoom: 12
    };

    return (
        <>
            <Header />
            <div className="page-content">
                <Banner title="تواصل معنا" pagename="تواصل معنا" bgimage={bnrimg} />

                <div className="section-full p-tb80 inner-page-padding">
                    <div className="container">
                        <div className="section-content">
                            <div className="row">
                                <div className="col-md-8 col-sm-6">
                                    <form className="contact-form cons-contact-form" onSubmit={handleSubmit}>
                                        <div className="contact-one m-b30">
                                            <div className="section-head">
                                                <div className="mt-separator-outer separator-left">
                                                    <div className="mt-separator">
                                                        <h2 className="text-uppercase sep-line-one " style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'Bold' }}>
                                                            <span className="font-weight-300 text-primary" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px' }}>تواصل</span> معنا
                                                        </h2>
                                                    </div>
                                                </div>
                                            </div>

                                            {submitted && <p className="text-success">✅ تم إرسال رسالتك بنجاح!</p>}
                                            {error && <p className="text-danger">❌ حدث خطأ: {error}</p>}

                                            <div className="form-group">
                                                <input name="name" type="text" value={formData.name} onChange={handleChange} required className="form-control" placeholder="الإسم" style={{ fontFamily: 'Cairo, sans-serif' }} />
                                            </div>
                                            <div className="form-group">
                                                <input name="email" type="email" value={formData.email} onChange={handleChange} required className="form-control" placeholder="الإيميل" style={{ fontFamily: 'Cairo, sans-serif' }} />
                                            </div>
                                            <div className="form-group">
                                                <textarea name="message" rows={4} value={formData.message} onChange={handleChange} className="form-control " required placeholder="الرسالة" style={{ fontFamily: 'Cairo, sans-serif' }} />
                                            </div>
                                            <div className="text-right">
                                                <button type="submit" className="site-button btn-effect" style={{ fontFamily: 'Cairo, sans-serif' }}>
                                                    إرسال
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                                {/* CONTACT INFO */}
                                <div className="col-md-4 col-sm-6">
                                    <div className="contact-info m-b30">
                                        <div className="section-head">
                                            <div className="mt-separator-outer separator-left">
                                                <div className="mt-separator">
                                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary"></span></h2>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="bg-dark p-a20 text-white">
                                            <div className="mt-icon-box-wraper left p-b40">
                                                <div className="icon-xs"><i className="fa fa-phone" /></div>
                                                <div className="icon-content">
                                                    <h5 className="m-t0 font-weight-500">رقم الهاتف</h5>
                                                    <p>+966 920002674</p>
                                                </div>
                                            </div>
                                            <div className="mt-icon-box-wraper left p-b40">
                                                <div className="icon-xs"><i className="fa fa-envelope" /></div>
                                                <div className="icon-content">
                                                    <h5 className="m-t0 font-weight-500">الإيميل</h5>
                                                    <p>info@alauss.com</p>
                                                </div>
                                            </div>
                                            <div className="mt-icon-box-wraper left">
                                                <div className="icon-xs"><i className="fa fa-map-marker" /></div>
                                                <div className="icon-content">
                                                    <h5 className="m-t0 font-weight-500">العنوان</h5>
                                                    <p>المملكة العربية السعودية - الاحساء</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                       
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default ContactUs;